<template>
  <div style="z-index: 1">
    <img v-if="src" :src="'images/96x96/' + src" :width="width" :height="height" />
  </div>
</template>

<script>
import MixinStates from "./mixin-states.js";

export default {
  name: "icon",
  mixins: [MixinStates],
  props: {
    src: {
      type: String,
      required: true,
      default: "",
    },
  },
};
</script>
